import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  trackClickForbiddenTextPopupButton,
  trackClickForbiddenTextPopupLink,
  trackCloseForbiddenTextPopup,
} from '../tracking';
import { setEditableMessage } from '../../../actions/chat/actions';
import { currentChatOpponentIdSelector, currentOpenChatSelector, hostTypeSelector } from '../../../selectors';
import { alertSelector } from '../../../selectors/alertSelector';
import { hideAlert } from '../../../slices/alertSlice';
import { EDeviceType } from '../../../types/deviceType';
import { EHostType } from '../../../types/hostType';

export const useForbiddenTextPopupHandler = () => {
  const dispatch = useDispatch();
  const device = useDeviceType();

  const { message, chatId } = useSelector(alertSelector);
  const chat = useSelector(currentOpenChatSelector);
  const opponentId = useSelector(currentChatOpponentIdSelector);
  const hostType = useSelector(hostTypeSelector);

  const isIframe = hostType === EHostType.Frame;
  const isMobile = device !== EDeviceType.Desktop;

  const handleClose = React.useCallback(
    (isClickedSubmitButton?: boolean) => {
      dispatch(setEditableMessage({ text: message as string, chatId: chatId as string }));
      dispatch(hideAlert());
      if (isClickedSubmitButton) {
        trackClickForbiddenTextPopupButton(chat, opponentId);

        return;
      }
      trackCloseForbiddenTextPopup(chat, opponentId);
    },
    [chat, chatId, dispatch, message, opponentId],
  );

  const handleClickLinkButton = React.useCallback(() => {
    trackClickForbiddenTextPopupLink(chat, opponentId);
  }, [chat, opponentId]);

  return {
    handleCloseNoForbiddenTextPopup: handleClose,
    handleClickNoForbiddenTextPopupLink: handleClickLinkButton,
    isMobile: isMobile || isIframe,
  };
};
